var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import mergeClassName from '@tencent/data-schema/lib/utils/mergeClassName';
import FormContainerBase from '../../plugins/form/FormContainerBase';
import { CalmComputedGetter } from "../../../../lib/utils";
import { focusEditor } from "../../../../lib/utils/browser/focusEditor";
import { isMobile } from "../../../../lib/utils/browser/isMobile";
import Markdown from '../Markdown/';
import MarkdownForTooltip from "../../../../lib/comps/MarkdownForTooltip";
let WFormItem = class WFormItem extends FormContainerBase {
  beforeCreate() {
    this.isFormItem = true;
  }
  get mergedClassName() {
    const fillLine = this.finalFillLine;
    const hasError = this.validateResults.length > 0;
    return mergeClassName(this.className, fillLine && 'is-fillLine', hasError && 'hasError', isMobile() && 'isMobile');
  }
  finalCss() {
    const isHidden = !this.isDesignMode && !this.$slots.default;
    return isHidden ? 'display: none;' : this.css;
  }
  get finalLabelCss() {
    const ans = [];
    const labelWidth = this.finalLayout !== 'vertical' && this.finalLabelWidth;
    if (labelWidth) {
      // 如果用户给的数字 就默认补px
      const labelWidthFinal = /^-?\d+\.?\d*$/.test(labelWidth) ? `${labelWidth}px` : labelWidth;
      ans.push(`width: ${labelWidthFinal}`);
    }
    return ans.join('; ');
  }
  get errorMessageLineNodes() {
    const h = this.$createElement;
    const results = this.validateResults;
    if (!results.length) return null;
    return h("ul", {
      "class": "w-formItem-errors"
    }, [this.validateResults.map((item, idx) => h("li", {
      "key": idx,
      "class": "w-formItem-error",
      "attrs": {
        "tabIndex": 0
      },
      "on": {
        "click": () => {
          focusEditor(item.editor);
        }
      }
    }, [String(item.message)]))]);
  }
  get descriptionLineNodes() {
    var _this$description;
    const h = this.$createElement;
    const description = String((_this$description = this.description) !== null && _this$description !== void 0 ? _this$description : '');
    if (!description) return null;
    if (this.finalTitleMode === 'pre') return h("div", {
      "class": "w-formItem-description",
      "style": {
        whiteSpace: 'pre-line'
      }
    }, [" ", description]);
    if (this.finalTitleMode === 'markdown') return h("markdown", {
      "attrs": {
        "source": description,
        "open-in-new-window": true
      },
      "class": "w-formItem-description"
    });
    return h("div", {
      "class": "w-formItem-description"
    }, [" ", description]);
  }
  get toolTipNodes() {
    var _this$tooltipText;
    const h = this.$createElement;
    const tooltipText = String((_this$tooltipText = this.tooltipText) !== null && _this$tooltipText !== void 0 ? _this$tooltipText : '');
    if (!tooltipText) return null;
    if (this.finalTitleMode === 'pre') return h("a-tooltip", [h("div", {
      "class": "w-formItem-tooltip-title",
      "slot": "title",
      "style": "white-space: pre-wrap"
    }, [tooltipText]), h("a-icon", {
      "attrs": {
        "type": "info-circle"
      },
      "class": "w-formItem-label-tooltip"
    })]);
    if (this.finalTitleMode === 'markdown') return h("a-tooltip", [h("markdown-for-tooltip", {
      "slot": "title",
      "attrs": {
        "source": tooltipText
      },
      "class": "w-formItem-tooltip-markdown w-formItem-tooltip-title"
    }), h("a-icon", {
      "attrs": {
        "type": "info-circle"
      },
      "class": "w-formItem-label-tooltip"
    })]);
    return h("a-tooltip", [h("div", {
      "slot": "title",
      "class": "w-formItem-tooltip-title"
    }, [tooltipText]), h("a-icon", {
      "attrs": {
        "type": "info-circle"
      },
      "class": "w-formItem-label-tooltip"
    })]);
  }
  get hasRequiredEditor() {
    if (this.required) return true;
    // eslint-disable-next-line no-restricted-syntax
    for (const editor of this.editors) {
      if (editor.required) return true;
    }
    // TODO: 要不要递归一下？
    return false;
  }
  render() {
    var _this$$slots$label;
    const h = arguments[0];
    const {
      label
    } = this;
    const finalRequired = this.hasRequiredEditor;
    return h("div", {
      "class": `w-formItem ${this.mergedClassName}`,
      "style": this.finalCss(),
      "attrs": {
        "data-layout": this.finalLayout,
        "label-vertical": this.finalLabelVertical
      }
    }, [!this.hideLabel && h("div", {
      "class": "w-formItem-label",
      "style": this.finalLabelCss
    }, [h("div", {
      "style": {
        'margin-left': finalRequired ? '-18px' : '0px'
      }
    }, [/* 必填的那个 */finalRequired && h("i", {
      "class": "w-formItem-label-requiredMark",
      "attrs": {
        "aria-hidden": "true"
      }
    }, ["*"])]), h("div", {
      "class": "w-formItem-label-text",
      "attrs": {
        "title": label
      }
    }, [(_this$$slots$label = this.$slots.label) !== null && _this$$slots$label !== void 0 ? _this$$slots$label : String(label)]), this.toolTipNodes]), h("div", {
      "class": ['w-formItem-editor', 'uc-slotForBlocks', this.disableMinWidth && 'w-formItem-editor-disableMinWidth'],
      "ref": "editorArea"
    }, [this.$slots.default || h("div", {
      "class": "w-formItem-editor-placeholder"
    }, ["\u8BF7\u5728\u8FD9\u91CC\u653E\u7F6E\u7F16\u8F91\u6846\u7EC4\u4EF6"])]), this.descriptionLineNodes, this.errorMessageLineNodes]);
  }
};
__decorate([CalmComputedGetter()], WFormItem.prototype, "hasRequiredEditor", null);
WFormItem = __decorate([Component({
  name: 'WFormItem',
  props: {
    className: {
      type: String,
      default: ''
    },
    css: {
      type: String,
      default: ''
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    tooltipText: {
      type: String,
      default: ''
    },
    disableMinWidth: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Markdown,
    MarkdownForTooltip
  }
})], WFormItem);
export default WFormItem;
//# sourceMappingURL=index.js.map
